import React, { FC, memo } from 'react'
import { makeStyles } from '@material-ui/core/styles'

import { FieldProps } from 'react-admin'

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    flexWrap: 'nowrap',
    alignItems: 'center',
    width: `240px`,
  },
  avatar: {
    marginRight: theme.spacing(1),
    marginTop: -theme.spacing(0.5),
    marginBottom: -theme.spacing(0.5),
  },
}))

interface Props extends FieldProps<any> {
  size?: string
}

const InvoiceHeaderRefField: FC<Props> = ({ record }) => {
  const classes = useStyles()
  return record ? <div className={classes.root}>CK{record.ref_invoice}</div> : null
}

InvoiceHeaderRefField.defaultProps = {
  source: 'ref_invoice',
  label: 'Ref Invoice',
}

export default memo<Props>(InvoiceHeaderRefField)
